import React from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import {
  makeStyles,
  Button,
  Modal,
  Backdrop,
  FormControl,
  InputAdornment,
  IconButton,
  Select,
  MenuItem,
  Typography,
} from "@material-ui/core";
import Grid from "@mui/material/Grid";
import { SET_FETCH_TAG_VALUE_CONTROL, set_vrf_tags } from "../../Action/Action";
import Store from "../../Store/Store";
import "../CSS/vrfkat1.css";
import LockIcon from "@mui/icons-material/Lock";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import CloseIcon from "@mui/icons-material/Close";
import kat1bg from "../../Assets/VRF/birinci-kat.png";
import DoneIcon from "@mui/icons-material/Done";
import CancelIcon from "@mui/icons-material/Cancel";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom/cjs/react-router-dom";

import { Input } from "@mui/material";
import { connect } from "react-redux";
const initalState = [
  {
    101: [
      { text: "Oda Sıcaklığı", tagId: "971" },
      { text: "Oda Set Değeri", tagId: "1105" },
      { text: "Cihaz", tagId: "1333", tagId2: "1455" },
      { text: "Çalışma Modu", tagId: "2694", tagId2: "2851" },
      { text: "Çalışma Durumu", tagId: "2694", tagId2: "2851" },

      { text: "Fan Modu", tagId: "8149", tagId2: "2852" },
      { text: "Soğutma Modu Set Değeri", tagId: "1106" },
      { text: "Isıtma Modu Set Değeri", tagId: "1107" },
      { text: "Filtre Durumu", tagId: "1335" },
      { text: "Filtre Reset", tagId: "1605" },
      { text: "Arıza Durumu", tagId: "7228" },
      { text: "Arıza Kodu", tagId: "2693" },
    ],
  },
  {
    102: [
      { text: "Oda Sıcaklığı", tagId: "970" },
      { text: "Oda Set Değeri", tagId: "1099" },
      { text: "Cihaz", tagId: "1329", tagId2: "1454" },
      { text: "Çalışma Modu", tagId: "2690", tagId2: "2848" },
      { text: "Çalışma Durumu", tagId: "2690", tagId2: "2848" },

      { text: "Fan Modu", tagId: "8145", tagId2: "2849" },
      { text: "Soğutma Modu Set Değeri", tagId: "1100" },
      { text: "Isıtma Modu Set Değeri", tagId: "1101" },
      { text: "Filtre Durumu", tagId: "1331" },
      { text: "Filtre Reset", tagId: "1598" },
      { text: "Arıza Durumu", tagId: "7225" },
      { text: "Arıza Kodu", tagId: "2689" },
    ],
  },
  {
    103: [
      { text: "Oda Sıcaklığı", tagId: "969" },
      { text: "Oda Set Değeri", tagId: "1093" },
      { text: "Cihaz", tagId: "1325", tagId2: "1453" },
      { text: "Çalışma Modu", tagId: "2686", tagId2: "2845" },
      { text: "Çalışma Durumu", tagId: "2686", tagId2: "2845" },

      { text: "Fan Modu", tagId: "8141", tagId2: "2846" },
      { text: "Soğutma Modu Set Değeri", tagId: "1094" },
      { text: "Isıtma Modu Set Değeri", tagId: "1095" },
      { text: "Filtre Durumu", tagId: "1327" },
      { text: "Filtre Reset", tagId: "1591" },
      { text: "Arıza Durumu", tagId: "7222" },
      { text: "Arıza Kodu", tagId: "2685" },
    ],
  },
  {
    104: [
      { text: "Oda Sıcaklığı", tagId: "968" },
      { text: "Oda Set Değeri", tagId: "1087" },
      { text: "Cihaz", tagId: "1321", tagId2: "1452" },
      { text: "Çalışma Modu", tagId: "2722", tagId2: "2842" },
      { text: "Çalışma Durumu", tagId: "2722", tagId2: "2842" },

      { text: "Fan Modu", tagId: "8137", tagId2: "2843" },
      { text: "Soğutma Modu Set Değeri", tagId: "1088" },
      { text: "Isıtma Modu Set Değeri", tagId: "1089" },
      { text: "Filtre Durumu", tagId: "1323" },
      { text: "Filtre Reset", tagId: "1585" },
      { text: "Arıza Durumu", tagId: "7219" },
      { text: "Arıza Kodu", tagId: "2681" },
    ],
  },
  {
    105: [
      { text: "Oda Sıcaklığı", tagId: "967" },
      { text: "Oda Set Değeri", tagId: "1081" },
      { text: "Cihaz", tagId: "1317", tagId2: "1451" },
      { text: "Çalışma Modu", tagId: "2678", tagId2: "2839" },
      { text: "Çalışma Durumu", tagId: "2678", tagId2: "2839" },

      { text: "Fan Modu", tagId: "8133", tagId2: "2840" },
      { text: "Soğutma Modu Set Değeri", tagId: "1082" },
      { text: "Isıtma Modu Set Değeri", tagId: "1083" },
      { text: "Filtre Durumu", tagId: "1319" },
      { text: "Filtre Reset", tagId: "1578" },
      { text: "Arıza Durumu", tagId: "7216" },
      { text: "Arıza Kodu", tagId: "2677" },
    ],
  },
  {
    106: [
      { text: "Oda Sıcaklığı", tagId: "966" },
      { text: "Oda Set Değeri", tagId: "1075" },
      { text: "Cihaz", tagId: "1313", tagId2: "1450" },
      { text: "Çalışma Modu", tagId: "2674", tagId2: "2836" },
      { text: "Çalışma Durumu", tagId: "2674", tagId2: "2836" },

      { text: "Fan Modu", tagId: "8129", tagId2: "2837" },
      { text: "Soğutma Modu Set Değeri", tagId: "1076" },
      { text: "Isıtma Modu Set Değeri", tagId: "1077" },
      { text: "Filtre Durumu", tagId: "1315" },
      { text: "Filtre Reset", tagId: "1571" },
      { text: "Arıza Durumu", tagId: "7213" },
      { text: "Arıza Kodu", tagId: "2673" },
    ],
  },
  {
    107: [
      { text: "Oda Sıcaklığı", tagId: "965" },
      { text: "Oda Set Değeri", tagId: "1069" },
      { text: "Cihaz", tagId: "1309", tagId2: "1449" },
      { text: "Çalışma Modu", tagId: "2670", tagId2: "2833" },
      { text: "Çalışma Durumu", tagId: "2670", tagId2: "2833" },

      { text: "Fan Modu", tagId: "8125", tagId2: "2834" },
      { text: "Soğutma Modu Set Değeri", tagId: "1070" },
      { text: "Isıtma Modu Set Değeri", tagId: "1071" },
      { text: "Filtre Durumu", tagId: "1311" },
      { text: "Filtre Reset", tagId: "1564" },
      { text: "Arıza Durumu", tagId: "7210" },
      { text: "Arıza Kodu", tagId: "2669" },
    ],
  },
  {
    108: [
      { text: "Oda Sıcaklığı", tagId: "964" },
      { text: "Oda Set Değeri", tagId: "1063" },
      { text: "Cihaz", tagId: "1305", tagId2: "1448" },
      { text: "Çalışma Modu", tagId: "2666", tagId2: "2830" },
      { text: "Çalışma Durumu", tagId: "2666", tagId2: "2830" },

      { text: "Fan Modu", tagId: "8121", tagId2: "2831" },
      { text: "Soğutma Modu Set Değeri", tagId: "1064" },
      { text: "Isıtma Modu Set Değeri", tagId: "1065" },
      { text: "Filtre Durumu", tagId: "1307" },
      { text: "Filtre Reset", tagId: "1557" },
      { text: "Arıza Durumu", tagId: "7207" },
      { text: "Arıza Kodu", tagId: "2665" },
    ],
  },
  {
    109: [
      { text: "Oda Sıcaklığı", tagId: "963" },
      { text: "Oda Set Değeri", tagId: "1057" },
      { text: "Cihaz", tagId: "1301", tagId2: "1447" },
      { text: "Çalışma Modu", tagId: "2662", tagId2: "2827" },
      { text: "Çalışma Durumu", tagId: "2662", tagId2: "2827" },

      { text: "Fan Modu", tagId: "8117", tagId2: "2828" },
      { text: "Soğutma Modu Set Değeri", tagId: "1058" },
      { text: "Isıtma Modu Set Değeri", tagId: "1059" },
      { text: "Filtre Durumu", tagId: "1303" },
      { text: "Filtre Reset", tagId: "1550" },
      { text: "Arıza Durumu", tagId: "7204" },
      { text: "Arıza Kodu", tagId: "2661" },
    ],
  },
  {
    110: [
      { text: "Oda Sıcaklığı", tagId: "962" },
      { text: "Oda Set Değeri", tagId: "1051" },
      { text: "Cihaz", tagId: "1297", tagId2: "1446" },
      { text: "Çalışma Modu", tagId: "2658", tagId2: "2824" },
      { text: "Çalışma Durumu", tagId: "2658", tagId2: "2824" },

      { text: "Fan Modu", tagId: "8113", tagId2: "2825" },
      { text: "Soğutma Modu Set Değeri", tagId: "1052" },
      { text: "Isıtma Modu Set Değeri", tagId: "1053" },
      { text: "Filtre Durumu", tagId: "1299" },
      { text: "Filtre Reset", tagId: "1543" },
      { text: "Arıza Durumu", tagId: "7201" },
      { text: "Arıza Kodu", tagId: "2657" },
    ],
  },
  {
    111: [
      { text: "Oda Sıcaklığı", tagId: "961" },
      { text: "Oda Set Değeri", tagId: "1045" },
      { text: "Cihaz", tagId: "1293", tagId2: "1445" },
      { text: "Çalışma Modu", tagId: "2654", tagId2: "2821" },
      { text: "Çalışma Durumu", tagId: "2654", tagId2: "2821" },

      { text: "Fan Modu", tagId: "8109", tagId2: "2822" },
      { text: "Soğutma Modu Set Değeri", tagId: "1046" },
      { text: "Isıtma Modu Set Değeri", tagId: "1047" },
      { text: "Filtre Durumu", tagId: "1295" },
      { text: "Filtre Reset", tagId: "1536" },
      { text: "Arıza Durumu", tagId: "7198" },
      { text: "Arıza Kodu", tagId: "2653" },
    ],
  },
  {
    112: [
      { text: "Oda Sıcaklığı", tagId: "960" },
      { text: "Oda Set Değeri", tagId: "1039" },
      { text: "Cihaz", tagId: "1289", tagId2: "1444" },
      { text: "Çalışma Modu", tagId: "2650", tagId2: "2818" },
      { text: "Çalışma Durumu", tagId: "2650", tagId2: "2818" },

      { text: "Fan Modu", tagId: "8105", tagId2: "2819" },
      { text: "Soğutma Modu Set Değeri", tagId: "1040" },
      { text: "Isıtma Modu Set Değeri", tagId: "1041" },
      { text: "Filtre Durumu", tagId: "1291" },
      { text: "Filtre Reset", tagId: "1529" },
      { text: "Arıza Durumu", tagId: "7195" },
      { text: "Arıza Kodu", tagId: "2649" },
    ],
  },
  {
    114: [
      { text: "Oda Sıcaklığı", tagId: "959" },
      { text: "Oda Set Değeri", tagId: "1033" },
      { text: "Cihaz", tagId: "1285", tagId2: "1443" },
      { text: "Çalışma Modu", tagId: "2646", tagId2: "2815" },
      { text: "Çalışma Durumu", tagId: "2646", tagId2: "2815" },

      { text: "Fan Modu", tagId: "8101", tagId2: "2816" },
      { text: "Soğutma Modu Set Değeri", tagId: "1034" },
      { text: "Isıtma Modu Set Değeri", tagId: "1035" },
      { text: "Filtre Durumu", tagId: "1287" },
      { text: "Filtre Reset", tagId: "1522" },
      { text: "Arıza Durumu", tagId: "7192" },
      { text: "Arıza Kodu", tagId: "2645" },
    ],
  },
  {
    115: [
      { text: "Oda Sıcaklığı", tagId: "958" },
      { text: "Oda Set Değeri", tagId: "1027" },
      { text: "Cihaz", tagId: "1281", tagId2: "1442" },
      { text: "Çalışma Modu", tagId: "2642", tagId2: "2812" },
      { text: "Çalışma Durumu", tagId: "2642", tagId2: "2812" },

      { text: "Fan Modu", tagId: "8097", tagId2: "2813" },
      { text: "Soğutma Modu Set Değeri", tagId: "1028" },
      { text: "Isıtma Modu Set Değeri", tagId: "1029" },
      { text: "Filtre Durumu", tagId: "1283" },
      { text: "Filtre Reset", tagId: "1515" },
      { text: "Arıza Durumu", tagId: "7189" },
      { text: "Arıza Kodu", tagId: "2641" },
    ],
  },
  {
    116: [
      { text: "Oda Sıcaklığı", tagId: "957" },
      { text: "Oda Set Değeri", tagId: "1021" },
      { text: "Cihaz", tagId: "1277", tagId2: "1441" },
      { text: "Çalışma Modu", tagId: "2638", tagId2: "2809" },
      { text: "Çalışma Durumu", tagId: "2638", tagId2: "2809" },

      { text: "Fan Modu", tagId: "8093", tagId2: "2810" },
      { text: "Soğutma Modu Set Değeri", tagId: "1022" },
      { text: "Isıtma Modu Set Değeri", tagId: "1023" },
      { text: "Filtre Durumu", tagId: "1279" },
      { text: "Filtre Reset", tagId: "1508" },
      { text: "Arıza Durumu", tagId: "7186" },
      { text: "Arıza Kodu", tagId: "2637" },
    ],
  },
  {
    117: [
      { text: "Oda Sıcaklığı", tagId: "956" },
      { text: "Oda Set Değeri", tagId: "1015" },
      { text: "Cihaz", tagId: "1273", tagId2: "1440" },
      { text: "Çalışma Modu", tagId: "2634", tagId2: "2806" },
      { text: "Çalışma Durumu", tagId: "2634", tagId2: "2806" },

      { text: "Fan Modu", tagId: "8089", tagId2: "2807" },
      { text: "Soğutma Modu Set Değeri", tagId: "1016" },
      { text: "Isıtma Modu Set Değeri", tagId: "1017" },
      { text: "Filtre Durumu", tagId: "1275" },
      { text: "Filtre Reset", tagId: "1501" },
      { text: "Arıza Durumu", tagId: "7183" },
      { text: "Arıza Kodu", tagId: "2633" },
    ],
  },
  {
    118: [
      { text: "Oda Sıcaklığı", tagId: "955" },
      { text: "Oda Set Değeri", tagId: "1009" },
      { text: "Cihaz", tagId: "1269", tagId2: "1439" },
      { text: "Çalışma Modu", tagId: "2630", tagId2: "2803" },
      { text: "Çalışma Durumu", tagId: "2630", tagId2: "2803" },

      { text: "Fan Modu", tagId: "8085", tagId2: "2804" },
      { text: "Soğutma Modu Set Değeri", tagId: "1010" },
      { text: "Isıtma Modu Set Değeri", tagId: "1011" },
      { text: "Filtre Durumu", tagId: "1271" },
      { text: "Filtre Reset", tagId: "1494" },
      { text: "Arıza Durumu", tagId: "7180" },
      { text: "Arıza Kodu", tagId: "2629" },
    ],
  },
  {
    119: [
      { text: "Oda Sıcaklığı", tagId: "954" },
      { text: "Oda Set Değeri", tagId: "1003" },
      { text: "Cihaz", tagId: "1265", tagId2: "1438" },
      { text: "Çalışma Modu", tagId: "2626", tagId2: "2800" },
      { text: "Çalışma Durumu", tagId: "2626", tagId2: "2800" },

      { text: "Fan Modu", tagId: "8081", tagId2: "2801" },
      { text: "Soğutma Modu Set Değeri", tagId: "1004" },
      { text: "Isıtma Modu Set Değeri", tagId: "1005" },
      { text: "Filtre Durumu", tagId: "1267" },
      { text: "Filtre Reset", tagId: "1487" },
      { text: "Arıza Durumu", tagId: "7177" },
      { text: "Arıza Kodu", tagId: "2625" },
    ],
  },
  {
    201: [
      { text: "Oda Sıcaklığı", tagId: "5055" },
      { text: "Oda Set Değeri", tagId: "5244" },
      { text: "Cihaz", tagId: "5450", tagId2: "5539" },
      { text: "Çalışma Modu", tagId: "6731", tagId2: "6877" },
      { text: "Çalışma Durumu", tagId: "6731", tagId2: "6877" },

      { text: "Fan Modu", tagId: "6732", tagId2: "6878" },
      { text: "Soğutma Modu Set Değeri", tagId: "5245" },
      { text: "Isıtma Modu Set Değeri", tagId: "5246" },
      { text: "Filtre Durumu", tagId: "5452" },
      { text: "Filtre Reset", tagId: "5728" },
      { text: "Arıza Durumu", tagId: "8643" },
      { text: "Arıza Kodu", tagId: "6730" },
    ],
  },
  {
    202: [
      { text: "Oda Sıcaklığı", tagId: "5056" },
      { text: "Oda Set Değeri", tagId: "5250" },
      { text: "Cihaz", tagId: "5454", tagId2: "5540" },
      { text: "Çalışma Modu", tagId: "6735", tagId2: "6880" },
      { text: "Çalışma Durumu", tagId: "6735", tagId2: "6880" },

      { text: "Fan Modu", tagId: "6736", tagId2: "6881" },
      { text: "Soğutma Modu Set Değeri", tagId: "5251" },
      { text: "Isıtma Modu Set Değeri", tagId: "5252" },
      { text: "Filtre Durumu", tagId: "5456" },
      { text: "Filtre Reset", tagId: "5734" },
      { text: "Arıza Durumu", tagId: "8647" },
      { text: "Arıza Kodu", tagId: "6734" },
    ],
  },
  {
    203: [
      { text: "Oda Sıcaklığı", tagId: "5057" },
      { text: "Oda Set Değeri", tagId: "5256" },
      { text: "Cihaz", tagId: "5458", tagId2: "5541" },
      { text: "Çalışma Modu", tagId: "6739", tagId2: "6883" },
      { text: "Çalışma Durumu", tagId: "6739", tagId2: "6883" },

      { text: "Fan Modu", tagId: "6740", tagId2: "6884" },
      { text: "Soğutma Modu Set Değeri", tagId: "5257" },
      { text: "Isıtma Modu Set Değeri", tagId: "5258" },
      { text: "Filtre Durumu", tagId: "5460" },
      { text: "Filtre Reset", tagId: "5740" },
      { text: "Arıza Durumu", tagId: "8651" },
      { text: "Arıza Kodu", tagId: "6738" },
    ],
  },
  {
    204: [
      { text: "Oda Sıcaklığı", tagId: "5058" },
      { text: "Oda Set Değeri", tagId: "5262" },
      { text: "Cihaz", tagId: "5462", tagId2: "5542" },
      { text: "Çalışma Modu", tagId: "6743", tagId2: "6886" },
      { text: "Çalışma Durumu", tagId: "6743", tagId2: "6886" },

      { text: "Fan Modu", tagId: "6744", tagId2: "6887" },
      { text: "Soğutma Modu Set Değeri", tagId: "5263" },
      { text: "Isıtma Modu Set Değeri", tagId: "5264" },
      { text: "Filtre Durumu", tagId: "5464" },
      { text: "Filtre Reset", tagId: "5746" },
      { text: "Arıza Durumu", tagId: "8655" },
      { text: "Arıza Kodu", tagId: "6742" },
    ],
  },
  {
    205: [
      { text: "Oda Sıcaklığı", tagId: "5059" },
      { text: "Oda Set Değeri", tagId: "5268" },
      { text: "Cihaz", tagId: "5466", tagId2: "5543" },
      { text: "Çalışma Modu", tagId: "6747", tagId2: "6889" },
      { text: "Çalışma Durumu", tagId: "6747", tagId2: "6889" },

      { text: "Fan Modu", tagId: "6748", tagId2: "6890" },
      { text: "Soğutma Modu Set Değeri", tagId: "5269" },
      { text: "Isıtma Modu Set Değeri", tagId: "5270" },
      { text: "Filtre Durumu", tagId: "5468" },
      { text: "Filtre Reset", tagId: "5752" },
      { text: "Arıza Durumu", tagId: "8659" },
      { text: "Arıza Kodu", tagId: "6746" },
    ],
  },
  {
    206: [
      { text: "Oda Sıcaklığı", tagId: "5060" },
      { text: "Oda Set Değeri", tagId: "5274" },
      { text: "Cihaz", tagId: "5470", tagId2: "5470" },
      { text: "Çalışma Modu", tagId: "6751", tagId2: "6892" },
      { text: "Çalışma Durumu", tagId: "6751", tagId2: "6892" },

      { text: "Fan Modu", tagId: "6752", tagId2: "6893" },
      { text: "Soğutma Modu Set Değeri", tagId: "5275" },
      { text: "Isıtma Modu Set Değeri", tagId: "5276" },
      { text: "Filtre Durumu", tagId: "5472" },
      { text: "Filtre Reset", tagId: "5758" },
      { text: "Arıza Durumu", tagId: "8663" },
      { text: "Arıza Kodu", tagId: "6750" },
    ],
  },
  {
    207: [
      { text: "Oda Sıcaklığı", tagId: "5061" },
      { text: "Oda Set Değeri", tagId: "5280" },
      { text: "Cihaz", tagId: "5474", tagId2: "5545" },
      { text: "Çalışma Modu", tagId: "6755", tagId2: "6895" },
      { text: "Çalışma Durumu", tagId: "6755", tagId2: "6895" },

      { text: "Fan Modu", tagId: "6756", tagId2: "6896" },
      { text: "Soğutma Modu Set Değeri", tagId: "5281" },
      { text: "Isıtma Modu Set Değeri", tagId: "5282" },
      { text: "Filtre Durumu", tagId: "5476" },
      { text: "Filtre Reset", tagId: "5764" },
      { text: "Arıza Durumu", tagId: "8667" },
      { text: "Arıza Kodu", tagId: "6754" },
    ],
  },
  {
    208: [
      { text: "Oda Sıcaklığı", tagId: "5062" },
      { text: "Oda Set Değeri", tagId: "5286" },
      { text: "Cihaz", tagId: "5478", tagId2: "5546" },
      { text: "Çalışma Modu", tagId: "6759", tagId2: "6898" },
      { text: "Çalışma Durumu", tagId: "6759", tagId2: "6898" },

      { text: "Fan Modu", tagId: "6760", tagId2: "6899" },
      { text: "Soğutma Modu Set Değeri", tagId: "5287" },
      { text: "Isıtma Modu Set Değeri", tagId: "5288" },
      { text: "Filtre Durumu", tagId: "5480" },
      { text: "Filtre Reset", tagId: "5770" },
      { text: "Arıza Durumu", tagId: "8671" },
      { text: "Arıza Kodu", tagId: "6758" },
    ],
  },
  {
    209: [
      { text: "Oda Sıcaklığı", tagId: "5063" },
      { text: "Oda Set Değeri", tagId: "5292" },
      { text: "Cihaz", tagId: "5482", tagId2: "5547" },
      { text: "Çalışma Modu", tagId: "6763", tagId2: "6901" },
      { text: "Çalışma Durumu", tagId: "6763", tagId2: "6901" },

      { text: "Fan Modu", tagId: "6764", tagId2: "6902" },
      { text: "Soğutma Modu Set Değeri", tagId: "5293" },
      { text: "Isıtma Modu Set Değeri", tagId: "5294" },
      { text: "Filtre Durumu", tagId: "5484" },
      { text: "Filtre Reset", tagId: "5776" },
      { text: "Arıza Durumu", tagId: "8675" },
      { text: "Arıza Kodu", tagId: "6762" },
    ],
  },
  {
    210: [
      { text: "Oda Sıcaklığı", tagId: "5064" },
      { text: "Oda Set Değeri", tagId: "5298" },
      { text: "Cihaz", tagId: "5486", tagId2: "5548" },
      { text: "Çalışma Modu", tagId: "6767", tagId2: "6904" },
      { text: "Çalışma Durumu", tagId: "6767", tagId2: "6904" },

      { text: "Fan Modu", tagId: "6768", tagId2: "6905" },
      { text: "Soğutma Modu Set Değeri", tagId: "5299" },
      { text: "Isıtma Modu Set Değeri", tagId: "5300" },
      { text: "Filtre Durumu", tagId: "5488" },
      { text: "Filtre Reset", tagId: "5782" },
      { text: "Arıza Durumu", tagId: "8679" },
      { text: "Arıza Kodu", tagId: "6766" },
    ],
  },
  {
    211: [
      { text: "Oda Sıcaklığı", tagId: "5065" },
      { text: "Oda Set Değeri", tagId: "5304" },
      { text: "Cihaz", tagId: "5490", tagId2: "5549" },
      { text: "Çalışma Modu", tagId: "6771", tagId2: "6907" },
      { text: "Çalışma Durumu", tagId: "6771", tagId2: "6907" },

      { text: "Fan Modu", tagId: "6772", tagId2: "6908" },
      { text: "Soğutma Modu Set Değeri", tagId: "5305" },
      { text: "Isıtma Modu Set Değeri", tagId: "5306" },
      { text: "Filtre Durumu", tagId: "5492" },
      { text: "Filtre Reset", tagId: "5788" },
      { text: "Arıza Durumu", tagId: "8683" },
      { text: "Arıza Kodu", tagId: "6770" },
    ],
  },
  {
    212: [
      { text: "Oda Sıcaklığı", tagId: "5066" },
      { text: "Oda Set Değeri", tagId: "5310" },
      { text: "Cihaz", tagId: "5494", tagId2: "5550" },
      { text: "Çalışma Modu", tagId: "6775", tagId2: "6910" },
      { text: "Çalışma Durumu", tagId: "6775", tagId2: "6910" },

      { text: "Fan Modu", tagId: "6776", tagId2: "6911" },
      { text: "Soğutma Modu Set Değeri", tagId: "5311" },
      { text: "Isıtma Modu Set Değeri", tagId: "5312" },
      { text: "Filtre Durumu", tagId: "5496" },
      { text: "Filtre Reset", tagId: "5794" },
      { text: "Arıza Durumu", tagId: "8687" },
      { text: "Arıza Kodu", tagId: "6774" },
    ],
  },
  {
    213: [
      { text: "Oda Sıcaklığı", tagId: "5067" },
      { text: "Oda Set Değeri", tagId: "5316" },
      { text: "Cihaz", tagId: "5498", tagId2: "5551" },
      { text: "Çalışma Modu", tagId: "6779", tagId2: "6913" },
      { text: "Çalışma Durumu", tagId: "6779", tagId2: "6913" },

      { text: "Fan Modu", tagId: "6780", tagId2: "6914" },
      { text: "Soğutma Modu Set Değeri", tagId: "5317" },
      { text: "Isıtma Modu Set Değeri", tagId: "5318" },
      { text: "Filtre Durumu", tagId: "5500" },
      { text: "Filtre Reset", tagId: "5800" },
      { text: "Arıza Durumu", tagId: "8691" },
      { text: "Arıza Kodu", tagId: "6778" },
    ],
  },
  {
    214: [
      { text: "Oda Sıcaklığı", tagId: "5068" },
      { text: "Oda Set Değeri", tagId: "5322" },
      { text: "Cihaz", tagId: "5502", tagId2: "5552" },
      { text: "Çalışma Modu", tagId: "6783", tagId2: "6916" },
      { text: "Çalışma Durumu", tagId: "6783", tagId2: "6916" },

      { text: "Fan Modu", tagId: "6784", tagId2: "6917" },
      { text: "Soğutma Modu Set Değeri", tagId: "5323" },
      { text: "Isıtma Modu Set Değeri", tagId: "5324" },
      { text: "Filtre Durumu", tagId: "5504" },
      { text: "Filtre Reset", tagId: "5806" },
      { text: "Arıza Durumu", tagId: "8695" },
      { text: "Arıza Kodu", tagId: "6782" },
    ],
  },
  {
    301: [
      { text: "Oda Sıcaklığı", tagId: "5053" },
      { text: "Oda Set Değeri", tagId: "5232" },
      { text: "Cihaz", tagId: "5442", tagId2: "5537" },
      { text: "Çalışma Modu", tagId: "6723", tagId2: "6871" },
      { text: "Çalışma Durumu", tagId: "6723", tagId2: "6871" },

      { text: "Fan Modu", tagId: "6724", tagId2: "6872" },
      { text: "Soğutma Modu Set Değeri", tagId: "5233" },
      { text: "Isıtma Modu Set Değeri", tagId: "5234" },
      { text: "Filtre Durumu", tagId: "5444" },
      { text: "Filtre Reset", tagId: "5716" },
      { text: "Arıza Durumu", tagId: "9635" },
      { text: "Arıza Kodu", tagId: "6722" },
    ],
  },
  {
    302: [
      { text: "Oda Sıcaklığı", tagId: "5052" },
      { text: "Oda Set Değeri", tagId: "5226" },
      { text: "Cihaz", tagId: "5438", tagId2: "5536" },
      { text: "Çalışma Modu", tagId: "6719", tagId2: "6868" },
      { text: "Çalışma Durumu", tagId: "6719", tagId2: "6868" },

      { text: "Fan Modu", tagId: "6720", tagId2: "6869" },
      { text: "Soğutma Modu Set Değeri", tagId: "5227" },
      { text: "Isıtma Modu Set Değeri", tagId: "5228" },
      { text: "Filtre Durumu", tagId: "5440" },
      { text: "Filtre Reset", tagId: "5710" },
      { text: "Arıza Durumu", tagId: "8631" },
      { text: "Arıza Kodu", tagId: "6718" },
    ],
  },
  {
    303: [
      { text: "Oda Sıcaklığı", tagId: "5051" },
      { text: "Oda Set Değeri", tagId: "5220" },
      { text: "Cihaz", tagId: "5434", tagId2: "5535" },
      { text: "Çalışma Modu", tagId: "6715", tagId2: "6865" },
      { text: "Çalışma Durumu", tagId: "6715", tagId2: "6865" },

      { text: "Fan Modu", tagId: "6716", tagId2: "6866" },
      { text: "Soğutma Modu Set Değeri", tagId: "5221" },
      { text: "Isıtma Modu Set Değeri", tagId: "5222" },
      { text: "Filtre Durumu", tagId: "5436" },
      { text: "Filtre Reset", tagId: "5704" },
      { text: "Arıza Durumu", tagId: "8627" },
      { text: "Arıza Kodu", tagId: "6714" },
    ],
  },
  {
    304: [
      { text: "Oda Sıcaklığı", tagId: "5050" },
      { text: "Oda Set Değeri", tagId: "5214" },
      { text: "Cihaz", tagId: "5430", tagId2: "5534" },
      { text: "Çalışma Modu", tagId: "6711", tagId2: "6862" },
      { text: "Çalışma Durumu", tagId: "6711", tagId2: "6862" },

      { text: "Fan Modu", tagId: "6712", tagId2: "6863" },
      { text: "Soğutma Modu Set Değeri", tagId: "5215" },
      { text: "Isıtma Modu Set Değeri", tagId: "5216" },
      { text: "Filtre Durumu", tagId: "5432" },
      { text: "Filtre Reset", tagId: "5698" },
      { text: "Arıza Durumu", tagId: "8623" },
      { text: "Arıza Kodu", tagId: "6710" },
    ],
  },
  {
    305: [
      { text: "Oda Sıcaklığı", tagId: "5049" },
      { text: "Oda Set Değeri", tagId: "5208" },
      { text: "Cihaz", tagId: "5426", tagId2: "5533" },
      { text: "Çalışma Modu", tagId: "6707", tagId2: "6859" },
      { text: "Çalışma Durumu", tagId: "6707", tagId2: "6859" },

      { text: "Fan Modu", tagId: "6708", tagId2: "6860" },
      { text: "Soğutma Modu Set Değeri", tagId: "5209" },
      { text: "Isıtma Modu Set Değeri", tagId: "5210" },
      { text: "Filtre Durumu", tagId: "5428" },
      { text: "Filtre Reset", tagId: "5692" },
      { text: "Arıza Durumu", tagId: "8619" },
      { text: "Arıza Kodu", tagId: "6706" },
    ],
  },
  {
    306: [
      { text: "Oda Sıcaklığı", tagId: "5048" },
      { text: "Oda Set Değeri", tagId: "5202" },
      { text: "Cihaz", tagId: "5422", tagId2: "5532" },
      { text: "Çalışma Modu", tagId: "6703", tagId2: "6856" },
      { text: "Çalışma Durumu", tagId: "6703", tagId2: "6856" },

      { text: "Fan Modu", tagId: "6704", tagId2: "6857" },
      { text: "Soğutma Modu Set Değeri", tagId: "5203" },
      { text: "Isıtma Modu Set Değeri", tagId: "5204" },
      { text: "Filtre Durumu", tagId: "5424" },
      { text: "Filtre Reset", tagId: "5686" },
      { text: "Arıza Durumu", tagId: "8615" },
      { text: "Arıza Kodu", tagId: "6702" },
    ],
  },
  {
    307: [
      { text: "Oda Sıcaklığı", tagId: "5047" },
      { text: "Oda Set Değeri", tagId: "5196" },
      { text: "Cihaz", tagId: "5418", tagId2: "5531" },
      { text: "Çalışma Modu", tagId: "6699", tagId2: "6853" },
      { text: "Çalışma Durumu", tagId: "6699", tagId2: "6853" },

      { text: "Fan Modu", tagId: "6700", tagId2: "6854" },
      { text: "Soğutma Modu Set Değeri", tagId: "5197" },
      { text: "Isıtma Modu Set Değeri", tagId: "5198" },
      { text: "Filtre Durumu", tagId: "5420" },
      { text: "Filtre Reset", tagId: "5680" },
      { text: "Arıza Durumu", tagId: "8611" },
      { text: "Arıza Kodu", tagId: "6698" },
    ],
  },
  {
    308: [
      { text: "Oda Sıcaklığı", tagId: "5046" },
      { text: "Oda Set Değeri", tagId: "5190" },
      { text: "Cihaz", tagId: "5414", tagId2: "5530" },
      { text: "Çalışma Modu", tagId: "6695", tagId2: "6850" },
      { text: "Çalışma Durumu", tagId: "6695", tagId2: "6850" },

      { text: "Fan Modu", tagId: "6699", tagId2: "6851" },
      { text: "Soğutma Modu Set Değeri", tagId: "5191" },
      { text: "Isıtma Modu Set Değeri", tagId: "5192" },
      { text: "Filtre Durumu", tagId: "5416" },
      { text: "Filtre Reset", tagId: "5674" },
      { text: "Arıza Durumu", tagId: "8607" },
      { text: "Arıza Kodu", tagId: "6694" },
    ],
  },
  {
    309: [
      { text: "Oda Sıcaklığı", tagId: "5045" },
      { text: "Oda Set Değeri", tagId: "5184" },
      { text: "Cihaz", tagId: "5410", tagId2: "5529" },
      { text: "Çalışma Modu", tagId: "6691", tagId2: "6847" },
      { text: "Çalışma Durumu", tagId: "6691", tagId2: "6847" },

      { text: "Fan Modu", tagId: "6692", tagId2: "6848" },
      { text: "Soğutma Modu Set Değeri", tagId: "5185" },
      { text: "Isıtma Modu Set Değeri", tagId: "5186" },
      { text: "Filtre Durumu", tagId: "5412" },
      { text: "Filtre Reset", tagId: "5668" },
      { text: "Arıza Durumu", tagId: "8603" },
      { text: "Arıza Kodu", tagId: "6690" },
    ],
  },
  {
    310: [
      { text: "Oda Sıcaklığı", tagId: "5044" },
      { text: "Oda Set Değeri", tagId: "5178" },
      { text: "Cihaz", tagId: "5406", tagId2: "5528" },
      { text: "Çalışma Modu", tagId: "6687", tagId2: "6844" },
      { text: "Çalışma Durumu", tagId: "6687", tagId2: "6844" },

      { text: "Fan Modu", tagId: "6688", tagId2: "6845" },
      { text: "Soğutma Modu Set Değeri", tagId: "5179" },
      { text: "Isıtma Modu Set Değeri", tagId: "5180" },
      { text: "Filtre Durumu", tagId: "5408" },
      { text: "Filtre Reset", tagId: "5662" },
      { text: "Arıza Durumu", tagId: "8599" },
      { text: "Arıza Kodu", tagId: "6686" },
    ],
  },

  {
    311: [
      { text: "Oda Sıcaklığı", tagId: "5043" },
      { text: "Oda Set Değeri", tagId: "5172" },
      { text: "Cihaz", tagId: "5402", tagId2: "5527" },
      { text: "Çalışma Modu", tagId: "6683", tagId2: "6841" },
      { text: "Çalışma Durumu", tagId: "6683", tagId2: "6841" },

      { text: "Fan Modu", tagId: "6684", tagId2: "6842" },
      { text: "Soğutma Modu Set Değeri", tagId: "5173" },
      { text: "Isıtma Modu Set Değeri", tagId: "5174" },
      { text: "Filtre Durumu", tagId: "5404" },
      { text: "Filtre Reset", tagId: "5656" },
      { text: "Arıza Durumu", tagId: "8595" },
      { text: "Arıza Kodu", tagId: "6682" },
    ],
  },
  {
    312: [
      { text: "Oda Sıcaklığı", tagId: "5042" },
      { text: "Oda Set Değeri", tagId: "5166" },
      { text: "Cihaz", tagId: "5398", tagId2: "5526" },
      { text: "Çalışma Modu", tagId: "6679", tagId2: "6838" },
      { text: "Çalışma Durumu", tagId: "6679", tagId2: "6838" },

      { text: "Fan Modu", tagId: "6680", tagId2: "6839" },
      { text: "Soğutma Modu Set Değeri", tagId: "5167" },
      { text: "Isıtma Modu Set Değeri", tagId: "5168" },
      { text: "Filtre Durumu", tagId: "5400" },
      { text: "Filtre Reset", tagId: "5650" },
      { text: "Arıza Durumu", tagId: "8591" },
      { text: "Arıza Kodu", tagId: "6678" },
    ],
  },
  {
    401: [
      { text: "Oda Sıcaklığı", tagId: "5040" },
      { text: "Oda Set Değeri", tagId: "5154" },
      { text: "Cihaz", tagId: "5390", tagId2: "5524" },
      { text: "Çalışma Modu", tagId: "6671", tagId2: "6832" },
      { text: "Çalışma Durumu", tagId: "6671" },

      { text: "Fan Modu", tagId: "6672", tagId2: "6833" },
      { text: "Soğutma Modu Set Değeri", tagId: "5155" },
      { text: "Isıtma Modu Set Değeri", tagId: "5156" },
      { text: "Filtre Durumu", tagId: "5392" },
      { text: "Filtre Reset", tagId: "5638" },
      { text: "Arıza Durumu", tagId: "8583" },
      { text: "Arıza Kodu", tagId: "6670" },
    ],
  },
  {
    402: [
      { text: "Oda Sıcaklığı", tagId: "5039" },
      { text: "Oda Set Değeri", tagId: "5148" },
      { text: "Cihaz", tagId: "5356", tagId2: "5523" },
      { text: "Çalışma Modu", tagId: "6667", tagId2: "6829" },
      { text: "Çalışma Durumu", tagId: "6667" },

      { text: "Fan Modu", tagId: "6668", tagId2: "6830" },
      { text: "Soğutma Modu Set Değeri", tagId: "5149" },
      { text: "Isıtma Modu Set Değeri", tagId: "5150" },
      { text: "Filtre Durumu", tagId: "5388" },
      { text: "Filtre Reset", tagId: "5632" },
      { text: "Arıza Durumu", tagId: "8579" },
      { text: "Arıza Kodu", tagId: "6666" },
    ],
  },
  {
    403: [
      { text: "Oda Sıcaklığı", tagId: "5038" },
      { text: "Oda Set Değeri", tagId: "5142" },
      { text: "Cihaz", tagId: "5382", tagId2: "5522" },
      { text: "Çalışma Modu", tagId: "6663", tagId2: "6826" },
      { text: "Çalışma Durumu", tagId: "6663" },

      { text: "Fan Modu", tagId: "6664", tagId2: "6827" },
      { text: "Soğutma Modu Set Değeri", tagId: "5143" },
      { text: "Isıtma Modu Set Değeri", tagId: "5144" },
      { text: "Filtre Durumu", tagId: "5384" },
      { text: "Filtre Reset", tagId: "5626" },
      { text: "Arıza Durumu", tagId: "8575" },
      { text: "Arıza Kodu", tagId: "6662" },
    ],
  },
  {
    404: [
      { text: "Oda Sıcaklığı", tagId: "5037" },
      { text: "Oda Set Değeri", tagId: "5136" },
      { text: "Cihaz", tagId: "5378", tagId2: "5521" },
      { text: "Çalışma Modu", tagId: "6659", tagId2: "6823" },
      { text: "Çalışma Durumu", tagId: "6659" },

      { text: "Fan Modu", tagId: "6660", tagId2: "6824" },
      { text: "Soğutma Modu Set Değeri", tagId: "5137" },
      { text: "Isıtma Modu Set Değeri", tagId: "5138" },
      { text: "Filtre Durumu", tagId: "5380" },
      { text: "Filtre Reset", tagId: "5620" },
      { text: "Arıza Durumu", tagId: "8571" },
      { text: "Arıza Kodu", tagId: "6658" },
    ],
  },
  {
    405: [
      { text: "Oda Sıcaklığı", tagId: "5036" },
      { text: "Oda Set Değeri", tagId: "5130" },
      { text: "Cihaz", tagId: "5374", tagId2: "5520" },
      { text: "Çalışma Modu", tagId: "6655", tagId2: "6820" },
      { text: "Çalışma Durumu", tagId: "6655" },

      { text: "Fan Modu", tagId: "6656", tagId2: "6821" },
      { text: "Soğutma Modu Set Değeri", tagId: "5131" },
      { text: "Isıtma Modu Set Değeri", tagId: "5132" },
      { text: "Filtre Durumu", tagId: "5376" },
      { text: "Filtre Reset", tagId: "5614" },
      { text: "Arıza Durumu", tagId: "8567" },
      { text: "Arıza Kodu", tagId: "6654" },
    ],
  },
  {
    406: [
      { text: "Oda Sıcaklığı", tagId: "5035" },
      { text: "Oda Set Değeri", tagId: "5124" },
      { text: "Cihaz", tagId: "5370", tagId2: "5519" },
      { text: "Çalışma Modu", tagId: "6651", tagId2: "6817" },
      { text: "Çalışma Durumu", tagId: "6651" },

      { text: "Fan Modu", tagId: "6652", tagId2: "6818" },
      { text: "Soğutma Modu Set Değeri", tagId: "5125" },
      { text: "Isıtma Modu Set Değeri", tagId: "5126" },
      { text: "Filtre Durumu", tagId: "5372" },
      { text: "Filtre Reset", tagId: "5608" },
      { text: "Arıza Durumu", tagId: "8563" },
      { text: "Arıza Kodu", tagId: "6650" },
    ],
  },
  {
    407: [
      { text: "Oda Sıcaklığı", tagId: "5034" },
      { text: "Oda Set Değeri", tagId: "5118" },
      { text: "Cihaz", tagId: "5366", tagId2: "5518" },
      { text: "Çalışma Modu", tagId: "6647", tagId2: "6814" },
      { text: "Çalışma Durumu", tagId: "6647" },

      { text: "Fan Modu", tagId: "6648", tagId2: "6815" },
      { text: "Soğutma Modu Set Değeri", tagId: "5119" },
      { text: "Isıtma Modu Set Değeri", tagId: "5120" },
      { text: "Filtre Durumu", tagId: "5368" },
      { text: "Filtre Reset", tagId: "5602" },
      { text: "Arıza Durumu", tagId: "8559" },
      { text: "Arıza Kodu", tagId: "6646" },
    ],
  },
  {
    408: [
      { text: "Oda Sıcaklığı", tagId: "5033" },
      { text: "Oda Set Değeri", tagId: "5112" },
      { text: "Cihaz", tagId: "5362", tagId2: "5517" },
      { text: "Çalışma Modu", tagId: "6643", tagId2: "6811" },
      { text: "Çalışma Durumu", tagId: "6643" },

      { text: "Fan Modu", tagId: "6644", tagId2: "6812" },
      { text: "Soğutma Modu Set Değeri", tagId: "5113" },
      { text: "Isıtma Modu Set Değeri", tagId: "5114" },
      { text: "Filtre Durumu", tagId: "5364" },
      { text: "Filtre Reset", tagId: "5596" },
      { text: "Arıza Durumu", tagId: "8555" },
      { text: "Arıza Kodu", tagId: "6642" },
    ],
  },
  {
    501: [
      { text: "Oda Sıcaklığı", tagId: "5032" },
      { text: "Oda Set Değeri", tagId: "5106" },
      { text: "Cihaz", tagId: "5358", tagId2: "5516" },
      { text: "Çalışma Modu", tagId: "6639", tagId2: "6808" },
      { text: "Çalışma Durumu", tagId: "6639" },
      { text: "Fan Modu", tagId: "6640", tagId2: "6809" },
      { text: "Soğutma Modu Set Değeri", tagId: "5107" },
      { text: "Isıtma Modu Set Değeri", tagId: "5108" },
      { text: "Filtre Durumu", tagId: "5360" },
      { text: "Filtre Reset", tagId: "5590" },
      { text: "Arıza Durumu", tagId: "8551" },
      { text: "Arıza Kodu", tagId: "6638" },
    ],
  },
  {
    502: [
      { text: "Oda Sıcaklığı", tagId: "5031" },
      { text: "Oda Set Değeri", tagId: "5100" },
      { text: "Cihaz", tagId: "5354", tagId2: "5515" },
      { text: "Çalışma Modu", tagId: "6635", tagId2: "6805" },
      { text: "Çalışma Durumu", tagId: "6635" },

      { text: "Fan Modu", tagId: "6636", tagId2: "6806" },
      { text: "Soğutma Modu Set Değeri", tagId: "5101" },
      { text: "Isıtma Modu Set Değeri", tagId: "5102" },
      { text: "Filtre Durumu", tagId: "5356" },
      { text: "Filtre Reset", tagId: "5584" },
      { text: "Arıza Durumu", tagId: "8547" },
      { text: "Arıza Kodu", tagId: "6634" },
    ],
  },
  {
    503: [
      { text: "Oda Sıcaklığı", tagId: "5030" },
      { text: "Oda Set Değeri", tagId: "5094" },
      { text: "Cihaz", tagId: "5350", tagId2: "5514" },
      { text: "Çalışma Modu", tagId: "6631", tagId2: "6802" },
      { text: "Çalışma Durumu", tagId: "6631" },

      { text: "Fan Modu", tagId: "6632", tagId2: "6803" },
      { text: "Soğutma Modu Set Değeri", tagId: "5095" },
      { text: "Isıtma Modu Set Değeri", tagId: "5096" },
      { text: "Filtre Durumu", tagId: "5352" },
      { text: "Filtre Reset", tagId: "5578" },
      { text: "Arıza Durumu", tagId: "8543" },
      { text: "Arıza Kodu", tagId: "6630" },
    ],
  },
  {
    504: [
      { text: "Oda Sıcaklığı", tagId: "5029" },
      { text: "Oda Set Değeri", tagId: "5088" },
      { text: "Cihaz", tagId: "5346", tagId2: "5513" },
      { text: "Çalışma Modu", tagId: "6627", tagId2: "6799" },
      { text: "Çalışma Durumu", tagId: "6627" },

      { text: "Fan Modu", tagId: "6628", tagId2: "6800" },
      { text: "Soğutma Modu Set Değeri", tagId: "5089" },
      { text: "Isıtma Modu Set Değeri", tagId: "5090" },
      { text: "Filtre Durumu", tagId: "5348" },
      { text: "Filtre Reset", tagId: "5572" },
      { text: "Arıza Durumu", tagId: "8539" },
      { text: "Arıza Kodu", tagId: "6626" },
    ],
  },
  {
    505: [
      { text: "Oda Sıcaklığı", tagId: "5028" },
      { text: "Oda Set Değeri", tagId: "5082" },
      { text: "Cihaz", tagId: "5342", tagId2: "5512" },
      { text: "Çalışma Modu", tagId: "6623", tagId2: "6796" },
      { text: "Çalışma Durumu", tagId: "6623" },

      { text: "Fan Modu", tagId: "6624", tagId2: "6797" },
      { text: "Soğutma Modu Set Değeri", tagId: "5083" },
      { text: "Isıtma Modu Set Değeri", tagId: "5084" },
      { text: "Filtre Durumu", tagId: "5344" },
      { text: "Filtre Reset", tagId: "5566" },
      { text: "Arıza Durumu", tagId: "8535" },
      { text: "Arıza Kodu", tagId: "6622" },
    ],
  },
  {
    506: [
      { text: "Oda Sıcaklığı", tagId: "5027" },
      { text: "Oda Set Değeri", tagId: "5076" },
      { text: "Cihaz", tagId: "5338", tagId2: "5511" },
      { text: "Çalışma Modu", tagId: "6619", tagId2: "6793" },
      { text: "Çalışma Durumu", tagId: "6619" },

      { text: "Fan Modu", tagId: "6620", tagId2: "6794" },
      { text: "Soğutma Modu Set Değeri", tagId: "5077" },
      { text: "Isıtma Modu Set Değeri", tagId: "5078" },
      { text: "Filtre Durumu", tagId: "5340" },
      { text: "Filtre Reset", tagId: "5560" },
      { text: "Arıza Durumu", tagId: "8531" },
      { text: "Arıza Kodu", tagId: "6618" },
    ],
  },
];

let vrf_teras = [
  {
    601: [
      { text: "Oda Sıcaklığı", tagId: "959" },
      { text: "Oda Set Değeri", tagId: "1033" },
      { text: "Cihaz", tagId: "1443" },
      { text: "Çalışma Modu", tagId: "2646" },
      { text: "Fan Modu", tagId: "2647" },
      { text: "Soğutma Modu Set Değeri", tagId: "1034" },
      { text: "Isıtma Modu Set Değeri", tagId: "1035" },
      { text: "Filtre Durumu", tagId: "1287" },
      { text: "Filtre Reset", tagId: "1522" },
      { text: "Arıza Durumu", tagId: "1286" },
      { text: "Arıza Kodu", tagId: "2645" },
    ],
  },
];
let revisedState = {};

initalState.forEach((room) => {
  const roomId = Object.keys(room)[0];
  const roomTags = room[roomId];

  roomTags.forEach((tag) => {
    const text = tag.text;
    const tagId = tag.tagId;

    if (!revisedState[text]) {
      revisedState[text] = [];
    }

    revisedState[text].push(tagId);
  });
});

vrf_teras.forEach((room) => {
  const roomId = Object.keys(room)[0];
  const roomTags = room[roomId];

  roomTags.forEach((tag) => {
    const text = tag.text;
    const tagId = tag.tagId;

    if (!revisedState[text]) {
      revisedState[text] = [];
    }

    revisedState[text].push(tagId);
  });
});

console.log(revisedState);
const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundImage: `url("${kat1bg}")`,
    backgroundSize: "contain",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    position: "relative",
    scale: 1.2,
  },

  lockButton: {
    marginLeft: theme.spacing(1),
  },
  floorTitle: {
    position: "absolute",
    top: "9%",
    left: "50%",
    transform: "translateX(-50%)",
    fontSize: "2rem !important",
    fontWeight: 600,
    color: "black",
    padding: theme.spacing(1),
  },
  navigationButtonForward: {
    position: "absolute",
    top: "10%",
    right: "12%",
    borderRadius: "15px",
    backgroundColor: "#fff",
    border: "3px solid rgba(238, 200, 108, 0.99)",
    fontWeight: 600,
    scale: 0.7,
  },
  navigationButtonBack: {
    position: "absolute",
    top: "15%",
    left: "18%",
    zIndex: 9999999,
    borderRadius: "15px",
    backgroundColor: "#fff",
    border: "3px solid rgba(238, 200, 108, 0.99)",
    fontWeight: 600,
  },
  button: {
    position: "absolute",
    width: "1.5%",
    height: "2.5%",
    fontSize: "0.6rem",

    backgroundColor: "rgb(237, 188, 69)",
    borderRadius: "20px",
    "&:focus": {
      outline: "none",
    },
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    maxWidth: 300,
    padding: theme.spacing(2, 4, 3),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    position: "relative",
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  statusRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    padding: theme.spacing(1),
    "&:not(:last-child)": {
      borderBottom: `1px solid ${theme.palette.divider}`,
    },
  },
  sogutmaısıtma: {
    padding: theme.spacing(1),
    "&:not(:last-child)": {
      borderBottom: `1px solid ${theme.palette.divider}`,
    },
  },
  statusLabel: {
    marginRight: theme.spacing(2),
    minWidth: "150px",
    fontWeight: 600,
  },
  formControl: {
    flexGrow: 1,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  select: {
    width: "100%",
  },
}));

const Dashboard_vrf = (props) => {
  const history = useHistory();

  const [isEditing1, setIsEditing1] = useState(false);

  const [isEditing4, setIsEditing4] = useState(false);

  const [active_rm2, Set_active_rm2] = useState(false); // render modal 2
  const [active, Set_active] = useState(false);

  const [locked, setLocked] = useState({
    101: { odasetdegeri: false },
  });

  const handleOdaSetDegeriDone = (roomNumber) => {};

  const initialOdaSetDegerler = {
    101: "25",
    102: "25",
    103: "25",
    104: "25",
    105: "25",
    106: "25",
    107: "25",
    108: "25",
    109: "25",
    110: "25",
    111: "25",
    112: "25",
    113: "25",
    114: "25",
    115: "25",
    116: "25",
    117: "25",
    118: "25",
  };

  const [odasetdegerler, setOdasetdegerler] = useState(initialOdaSetDegerler);
  const [initialOdasetdegerler, setInitialOdasetdegerler] = useState(
    initialOdaSetDegerler
  );

  const [fanmoduselectValue, setfanmoduSelectValue] = useState("AUTO");
  const [calismamoduselectValue, setcalismamoduSelectValue] =
    useState("ISITMA");
  const [cihazselectValue, setcihazSelectValue] = useState("ON");
  const [cihazled, Setcihazled] = useState("green");

  const toggleLock = (roomNumber, selectType) => {
    setLocked((prevLocked) => {
      const newLocked = {
        ...prevLocked,
        [roomNumber]: {
          ...prevLocked[roomNumber],
          [selectType]: !prevLocked[roomNumber]?.[selectType],
        },
      };
      console.log("kilitlendi:", newLocked);
      return newLocked;
    });
  };

  const [isEditingCalismaModu, setIsEditingCalismaModu] = useState(false);
  const [isEditingFanModu, setIsEditingFanModu] = useState(false);
  const [isEditingReset, setIsEditingReset] = useState(false);

  const handleEditStart1 = () => {
    setIsEditing1(true);
  };

  const handleEditStart4 = () => {
    setIsEditing4(true);
  };

  const handleEditCancel1 = () => {
    setIsEditing1(false);
    // İptal durumunda orijinal değeri geri yükleyebilirsiniz
  };

  const handleEditDone1 = () => {
    setIsEditing1(false);
    // Değerin kaydedilmesi veya diğer işlemleri buraya ekleyebilirsiniz
  };

  const handleEditCancel4 = () => {
    setIsEditing4(false);
    // İptal durumunda orijinal değeri geri yükleyebilirsiniz
  };

  const handleEditDone4 = () => {
    setIsEditing4(false);
    // Değerin kaydedilmesi veya diğer işlemleri buraya ekleyebilirsiniz
  };

  const sendSetValueFunc = async (list_) => {
    const req = await fetch(
      "https://app-rmmscmdapi.azurewebsites.net/api/cmd/SetValue",
      {
        method: "POST",
        headers: {
          "Content-type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(list_),
      }
    );

    const response = await req.json();

    if (req.status === 200) {
      const inital_func = () => {
        var obj__ = [];
        var obj2__ = [];

        initalState.forEach((item) => {
          Object.entries(item).forEach((a) => {
            obj__.push(a[1]);
          });
        });

        obj__.forEach((item2) => {
          item2.forEach((item3) => {
            obj2__.push({ tagId: item3.tagId });
          });
        });

        setInterval(() => {
          const fetch_tag_values = async () => {
            if (window.location.pathname === "/vrf1") {
              try {
                const request = await fetch(
                  "https://app-rmmsapi.azurewebsites.net/api/tags/GetTagValues",
                  {
                    headers: {
                      "Content-Type": "application/json",
                      accept: "application/json",
                    },
                    method: "POST",
                    body: JSON.stringify(obj2__),
                  }
                );
                const response = await request.json();

                console.log(response);

                // response.forEach(a=>{
                //     liste.push(a)
                // })

                Store.dispatch(set_vrf_tags(response));
              } catch (err) {
                console.log(err);
              } finally {
                Store.dispatch(SET_FETCH_TAG_VALUE_CONTROL(false));
              }
            }
          };
          fetch_tag_values();
        }, 40000);
      };

      setTimeout(() => {
        inital_func();
      }, 3000);
    } else {
    }
  };

  // const fakeSendSetValueFunc = async (list_) => {
  //
  //   try {
  //     console.log("fakeSendSetValueFunc çağrıldı", list_);

  //     // Fake API yanıtını simüle et
  //     const fakeApiResponse = {
  //       status: 200,
  //       json: async () => ({
  //         success: true,
  //         message: "Fake API çağrısı başarılı!",
  //         data: list_,
  //       }),
  //     };

  //     // API yanıtını işleyelim
  //     const response = await fakeApiResponse.json();
  //     console.log("Fake API yanıtı:", response);
  //     console.log("HTTP durum kodu:", fakeApiResponse.status);

  //     if (fakeApiResponse.status === 200) {
  //       console.log("Fake API çağrısı başarılı, veriler güncelleniyor.");

  //       // Tag değerlerini al
  //       var obj__ = [];
  //       var obj2__ = [];

  //       initalState.forEach((item) => {
  //         Object.entries(item).forEach((a) => {
  //           obj__.push(a[1]);
  //         });
  //       });

  //       obj__.forEach((item2) => {
  //         item2.forEach((item3) => {
  //           obj2__.push({ tagId: item3.tagId });
  //           // tagId2 varsa onu da ekleyelim
  //           if (item3.tagId2) {
  //             obj2__.push({ tagId: item3.tagId2 });
  //           }
  //         });
  //       });

  //       console.log("Tag ID'leri:", obj2__);

  //       // Fake tag değerlerini al ve güncelle
  //       const fakeFetchTagValues = async () => {
  //         if (window.location.pathname === "/vrf3") {
  //           try {
  //             const fakeTagResponse = obj2__.map((tag) => ({
  //               tagId: tag.tagId,
  //               value: Math.random() * 100, // Rastgele bir değer döndür
  //             }));

  //             const updatedResponse = fakeTagResponse.map((item) => {
  //               const matchedItem = obj2__.find(
  //                 (objItem) => objItem.tagId === item.tagId
  //               );
  //               return {
  //                 ...item,
  //                 tagId2: matchedItem ? matchedItem.tagId : null,
  //               };
  //             });

  //             console.log("Fake tag değerleri alındı:", updatedResponse);

  //             Store.dispatch(set_vrf_tags(updatedResponse));
  //           } catch (err) {
  //             console.log("Fake tag değerleri fetch hatası:", err);
  //           } finally {
  //             Store.dispatch(SET_FETCH_TAG_VALUE_CONTROL(false));
  //           }
  //         }
  //       };

  //       await fakeFetchTagValues();
  //     } else {
  //       console.log("Fake API çağrısı başarısız:", fakeApiResponse.status);
  //     }
  //   } catch (error) {
  //     console.log("fakeSendSetValueFunc hatası:", error);
  //   }
  // };

  const [changed_values, Set_changed_values] = useState([]);

  const [setDegerleri2, SETSetDegerleri2] = useState(false);

  console.log(revisedState);

  const renderModalContent2 = (roomNumber) => {
    return (
      <div className={classes.paper + " vrf-popup-kapsayici"}>
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={() => {
            Set_active_rm2(false);
            SETSetDegerleri2(false);
          }}
        >
          <CloseIcon />
        </IconButton>
        <Typography
          variant="h2"
          style={{ color: "rgb(28,28,28)" }}
          gutterBottom
          id="oda-pop-up-baslik"
        >
          {"GENEL SİSTEM"}
        </Typography>
        <div className="vrf-popup-select">
          {Object.entries(revisedState).map((item, index) => {
            console.log(item);
            var title = [];
            var obj_ = [];
            Object.entries(item).forEach((a) => {
              if (a[0] === String(roomNumber)) {
                title.push(a[0]);
                obj_.push(a[1]);
              }
            });
            return (
              <div style={{ width: "100%", marginRight: "16px" }}>
                {item.map((x, index) => {
                  if (index < 1) {
                    switch (item[0]) {
                      case "Oda Set Değeri":
                        var değerler = props.vrf_tags
                          .filter((a) => String(a.tagId) === String(item[1][0]))
                          .map((b) => b.tagValue);
                        var değerler_eleman = değerler[0];
                        const genel_oda_set_değeri = değerler_eleman;
                        return (
                          <div className={classes.statusRow}>
                            <Typography
                              variant="subtitle1"
                              className={classes.statusLabel}
                            >
                              {item[0]} :
                            </Typography>
                            <FormControl
                              variant="outlined"
                              className={classes.formControl}
                              style={{ minWidth: "60px" }}
                            >
                              <Input
                                labelId={`oda${roomNumber}-oda-set-degeri-label`}
                                id={`oda${roomNumber}-oda-set-degeri-input`}
                                sx={{ fontWeight: 600 }}
                                type="number"
                                disabled={locked[roomNumber]?.odasetdegeri}
                                onChange={(e) => {
                                  Set_active(true);
                                  değerler_eleman = e.target.value;
                                  let newdata = changed_values;

                                  SETSetDegerleri2(true);

                                  var toplam_ = 0;
                                  newdata.forEach((a) => {
                                    if (a.name === "SET") {
                                      toplam_++;
                                      a.value = değerler_eleman;
                                    }
                                  });

                                  if (toplam_ < 1) {
                                    newdata.push({
                                      name: "SET",
                                      value: değerler_eleman,
                                    });
                                  }
                                }}
                                endAdornment={
                                  <InputAdornment position="end">
                                    °C
                                  </InputAdornment>
                                }
                              />
                            </FormControl>
                            <IconButton
                              onClick={() =>
                                toggleLock(roomNumber, "odasetdegeri")
                              }
                              className={classes.lockButton}
                              style={{
                                transform:
                                  initialOdasetdegerler[roomNumber] !==
                                  odasetdegerler[roomNumber]
                                    ? "scale(0.7)"
                                    : "scale(1)",
                              }}
                            >
                              {locked[roomNumber]?.odasetdegeri ? (
                                <LockIcon />
                              ) : (
                                <LockOpenIcon />
                              )}
                            </IconButton>
                            {/* {active && (
                              <div
                                style={{ position: "absolute", left: "30%" }}
                              >
                                <IconButton
                                  onClick={() => {
                                    Set_active(false);
                                    revisedState["Oda Set Değeri"].forEach(
                                      async (i) => {
                                        await fakeSendSetValueFunc({
                                          TagId: i,
                                          TagValue: değerler_eleman,
                                        });
                                      }
                                    );
                                    handleOdaSetDegeriDone(roomNumber);
                                  }}
                                  size="small"
                                  style={{ color: "green" }}
                                >
                                  <DoneIcon />
                                </IconButton>
                                <IconButton
                                  onClick={() => {
                                    Set_active(false);
                                    setOdasetdegerler((prevValues) => ({
                                      ...prevValues,
                                      [roomNumber]:
                                        initialOdasetdegerler[roomNumber],
                                    }));
                                  }}
                                  size="small"
                                  style={{ color: "red" }}
                                >
                                  <CancelIcon />
                                </IconButton>
                              </div>
                            )} */}
                          </div>
                        );
                      case "Cihaz":
                        var değerler = props.vrf_tags
                          .filter((a) => String(a.tagId) === String(item[1][0]))
                          .map((b) => b.tagValue);

                        var değerler_eleman = değerler[0];

                        var cihazRengi =
                          değerler_eleman === "0 " ? "gray" : "green";

                        // CihazState değerine göre yuvarlağın rengini belirleme

                        return (
                          <div className={classes.statusRow}>
                            <Typography
                              variant="subtitle1"
                              className={classes.statusLabel}
                            >
                              Cihaz :
                            </Typography>

                            <FormControl
                              variant="outlined"
                              className={classes.formControl}
                              disabled={locked[roomNumber]?.device}
                            >
                              <div
                                onClick={(e) => {
                                  e.target.nextElementSibling.classList.toggle(
                                    "cihaz_modu_menu_active"
                                  );
                                }}
                                className="cihaz_modu_div"
                              >
                                {değerler_eleman === "0 " ? "OFF" : "ON"}
                              </div>
                              <ul className="cihaz_modu_menu">
                                <li
                                  onClick={(e) => {
                                    SETSetDegerleri2(true);

                                    var textCurrent = e.target.textContent;
                                    console.log(textCurrent);

                                    let newdata = changed_values;

                                    var toplam_ = 0;
                                    newdata.forEach((a) => {
                                      if (a.name === "CİHAZ") {
                                        toplam_++;
                                        a.value = "ON";
                                      }
                                    });

                                    if (toplam_ < 1) {
                                      newdata.push({
                                        name: "CİHAZ",
                                        value: "ON",
                                      });
                                    }

                                    e.target.parentElement.classList.toggle(
                                      "cihaz_modu_menu_active"
                                    );
                                    e.target.parentElement.previousElementSibling.innerHTML =
                                      textCurrent;
                                    // document.querySelector(
                                    //   ".deviceStatusIndicator"
                                    // ).style.backgroundColor = "green";
                                  }}
                                >
                                  ON
                                </li>
                                <li
                                  onClick={(e) => {
                                    var textCurrent = e.target.textContent;

                                    SETSetDegerleri2(true);

                                    let newdata = changed_values;
                                    var toplam_ = 0;
                                    newdata.forEach((a) => {
                                      if (a.name === "CİHAZ") {
                                        toplam_++;
                                        a.value = "OFF";
                                      }
                                    });

                                    if (toplam_ < 1) {
                                      newdata.push({
                                        name: "CİHAZ",
                                        value: "OFF",
                                      });
                                    }

                                    e.target.parentElement.classList.toggle(
                                      "cihaz_modu_menu_active"
                                    );
                                    e.target.parentElement.previousElementSibling.innerHTML =
                                      textCurrent;
                                    // document.querySelector(
                                    //   ".deviceStatusIndicator"
                                    // ).style.backgroundColor = "gray";
                                  }}
                                >
                                  OFF
                                </li>
                              </ul>
                            </FormControl>

                            <IconButton
                              onClick={() => toggleLock(roomNumber, "device")}
                              className={classes.lockButton}
                            >
                              {locked[roomNumber]?.device ? (
                                <LockIcon />
                              ) : (
                                <LockOpenIcon />
                              )}
                            </IconButton>
                          </div>
                        );
                      case "Çalışma Modu":
                        var değerler = props.vrf_tags
                          .filter((a) => String(a.tagId) === String(item[1][0]))
                          .map((b) => b.tagValue);
                        var değerler_eleman = değerler[0];
                        console.log(değerler_eleman);

                        return (
                          <div className={classes.statusRow}>
                            <Typography
                              variant="subtitle1"
                              className={classes.statusLabel}
                            >
                              Çalışma Modu :
                            </Typography>
                            <FormControl
                              variant="outlined"
                              className={classes.formControl}
                              disabled={locked[roomNumber]?.mode}
                            >
                              <div
                                onClick={(e) => {
                                  e.target.nextElementSibling.classList.toggle(
                                    "calisma_modu_menu_active"
                                  );
                                }}
                                className="calisma_modu_div"
                              >
                                {değerler_eleman === "2 "
                                  ? "ISITMA"
                                  : değerler_eleman === "1 "
                                  ? "SOĞUTMA"
                                  : değerler_eleman === "5 "
                                  ? "NEM ALMA"
                                  : değerler_eleman === "4 "
                                  ? "AUTO"
                                  : "FAN"}
                              </div>
                              <ul className="calisma_modu_menu">
                                <li
                                  onClick={(e) => {
                                    SETSetDegerleri2(true);

                                    let newdata = changed_values;

                                    var textCurrent = e.target.textContent;
                                    console.log(textCurrent);

                                    var toplam_ = 0;
                                    newdata.forEach((a) => {
                                      if (a.name === "ÇALIŞMA") {
                                        toplam_++;
                                        a.value = "ISITMA";
                                      }
                                    });

                                    if (toplam_ < 1) {
                                      newdata.push({
                                        name: "ÇALIŞMA",
                                        value: "ISITMA",
                                      });
                                    }

                                    e.target.parentElement.classList.toggle(
                                      "calisma_modu_menu_active"
                                    );
                                    e.target.parentElement.previousElementSibling.innerHTML =
                                      textCurrent;
                                  }}
                                >
                                  ISITMA
                                </li>
                                <li
                                  onClick={(e) => {
                                    SETSetDegerleri2(true);

                                    let newdata = changed_values;

                                    var textCurrent = e.target.textContent;
                                    console.log(textCurrent);

                                    var toplam_ = 0;
                                    newdata.forEach((a) => {
                                      if (a.name === "ÇALIŞMA") {
                                        toplam_++;
                                        a.value = "SOĞUTMA";
                                      }
                                    });

                                    if (toplam_ < 1) {
                                      newdata.push({
                                        name: "ÇALIŞMA",
                                        value: "SOĞUTMA",
                                      });
                                    }

                                    e.target.parentElement.classList.toggle(
                                      "calisma_modu_menu_active"
                                    );
                                    e.target.parentElement.previousElementSibling.innerHTML =
                                      textCurrent;
                                  }}
                                >
                                  SOĞUTMA
                                </li>
                                <li
                                  onClick={(e) => {
                                    let newdata = changed_values;

                                    SETSetDegerleri2(true);

                                    var textCurrent = e.target.textContent;
                                    console.log(textCurrent);

                                    var toplam_ = 0;
                                    newdata.forEach((a) => {
                                      if (a.name === "ÇALIŞMA") {
                                        toplam_++;
                                        a.value = "NEM ALMA";
                                      }
                                    });

                                    if (toplam_ < 1) {
                                      newdata.push({
                                        name: "ÇALIŞMA",
                                        value: "NEM ALMA",
                                      });
                                    }

                                    e.target.parentElement.classList.toggle(
                                      "calisma_modu_menu_active"
                                    );
                                    e.target.parentElement.previousElementSibling.innerHTML =
                                      textCurrent;
                                  }}
                                >
                                  NEM ALMA
                                </li>
                                <li
                                  onClick={(e) => {
                                    let newdata = changed_values;

                                    SETSetDegerleri2(true);

                                    var textCurrent = e.target.textContent;
                                    console.log(textCurrent);

                                    var toplam_ = 0;
                                    newdata.forEach((a) => {
                                      if (a.name === "ÇALIŞMA") {
                                        toplam_++;
                                        a.value = "FAN";
                                      }
                                    });

                                    if (toplam_ < 1) {
                                      newdata.push({
                                        name: "ÇALIŞMA",
                                        value: "FAN",
                                      });
                                    }

                                    e.target.parentElement.classList.toggle(
                                      "calisma_modu_menu_active"
                                    );
                                    e.target.parentElement.previousElementSibling.innerHTML =
                                      textCurrent;
                                  }}
                                >
                                  FAN
                                </li>
                                <li
                                  onClick={(e) => {
                                    let newdata = changed_values;

                                    SETSetDegerleri2(true);

                                    var textCurrent = e.target.textContent;
                                    console.log(textCurrent);

                                    var toplam_ = 0;
                                    newdata.forEach((a) => {
                                      if (a.name === "ÇALIŞMA") {
                                        toplam_++;
                                        a.value = "AUTO";
                                      }
                                    });

                                    if (toplam_ < 1) {
                                      newdata.push({
                                        name: "ÇALIŞMA",
                                        value: "AUTO",
                                      });
                                    }

                                    e.target.parentElement.classList.toggle(
                                      "calisma_modu_menu_active"
                                    );
                                    e.target.parentElement.previousElementSibling.innerHTML =
                                      textCurrent;
                                  }}
                                >
                                  AUTO
                                </li>
                              </ul>
                            </FormControl>

                            <IconButton
                              onClick={() => toggleLock(roomNumber, "mode")}
                              className={classes.lockButton}
                            >
                              {locked[roomNumber]?.mode ? (
                                <LockIcon />
                              ) : (
                                <LockOpenIcon />
                              )}
                            </IconButton>
                          </div>
                        );
                      case "Fan Modu":
                        var değerler = props.vrf_tags
                          .filter((a) => String(a.tagId) === String(item[1][0]))
                          .map((b) => b.tagValue);
                        var değerler_eleman = değerler[0];
                        return (
                          <div className={classes.statusRow}>
                            <Typography
                              variant="subtitle1"
                              className={classes.statusLabel}
                            >
                              Fan Modu :
                            </Typography>
                            <FormControl
                              variant="outlined"
                              className={classes.formControl}
                            >
                              <div
                                style={{ right: "1%" }}
                                onClick={(e) => {
                                  e.target.nextElementSibling.classList.toggle(
                                    "fan_modu_menu_active"
                                  );
                                }}
                                className="fan_modu_div"
                              >
                                {değerler_eleman === "5 "
                                  ? "AUTO"
                                  : değerler_eleman}
                              </div>
                              <ul className="fan_modu_menu">
                                <li
                                  onClick={(e) => {
                                    let newdata = changed_values;

                                    var textCurrent = e.target.textContent;
                                    console.log(textCurrent);

                                    SETSetDegerleri2(true);

                                    var toplam_ = 0;
                                    newdata.forEach((a) => {
                                      if (a.name === "FAN") {
                                        toplam_++;
                                        a.value = textCurrent;
                                      }
                                    });

                                    if (toplam_ < 1) {
                                      newdata.push({
                                        name: "FAN",
                                        value: textCurrent,
                                      });
                                    }

                                    SETSetDegerleri2(true);

                                    e.target.parentElement.classList.toggle(
                                      "fan_modu_menu_active"
                                    );
                                    e.target.parentElement.previousElementSibling.innerHTML =
                                      textCurrent;
                                  }}
                                >
                                  DÜŞÜK
                                </li>
                                <li
                                  onClick={(e) => {
                                    let newdata = changed_values;

                                    var textCurrent = e.target.textContent;
                                    console.log(textCurrent);

                                    var toplam_ = 0;
                                    newdata.forEach((a) => {
                                      if (a.name === "FAN") {
                                        toplam_++;
                                        a.value = textCurrent;
                                      }
                                    });

                                    SETSetDegerleri2(true);

                                    if (toplam_ < 1) {
                                      newdata.push({
                                        name: "FAN",
                                        value: textCurrent,
                                      });
                                    }

                                    e.target.parentElement.classList.toggle(
                                      "fan_modu_menu_active"
                                    );
                                    e.target.parentElement.previousElementSibling.innerHTML =
                                      textCurrent;
                                  }}
                                >
                                  ORTA
                                </li>
                                <li
                                  onClick={(e) => {
                                    let newdata = changed_values;

                                    var textCurrent = e.target.textContent;
                                    console.log(textCurrent);

                                    var toplam_ = 0;
                                    newdata.forEach((a) => {
                                      if (a.name === "FAN") {
                                        toplam_++;
                                        a.value = textCurrent;
                                      }
                                    });

                                    if (toplam_ < 1) {
                                      newdata.push({
                                        name: "FAN",
                                        value: textCurrent,
                                      });
                                    }

                                    e.target.parentElement.classList.toggle(
                                      "fan_modu_menu_active"
                                    );
                                    e.target.parentElement.previousElementSibling.innerHTML =
                                      textCurrent;
                                  }}
                                >
                                  ORTA 2
                                </li>
                                <li
                                  onClick={(e) => {
                                    let newdata = changed_values;

                                    var textCurrent = e.target.textContent;
                                    console.log(textCurrent);

                                    var toplam_ = 0;
                                    newdata.forEach((a) => {
                                      if (a.name === "FAN") {
                                        toplam_++;
                                        a.value = textCurrent;
                                      }
                                    });

                                    SETSetDegerleri2(true);

                                    if (toplam_ < 1) {
                                      newdata.push({
                                        name: "FAN",
                                        value: textCurrent,
                                      });
                                    }

                                    e.target.parentElement.classList.toggle(
                                      "fan_modu_menu_active"
                                    );
                                    e.target.parentElement.previousElementSibling.innerHTML =
                                      textCurrent;
                                  }}
                                >
                                  HIZLI
                                </li>
                                <li
                                  onClick={(e) => {
                                    let newdata = changed_values;

                                    var textCurrent = e.target.textContent;
                                    console.log(textCurrent);

                                    var toplam_ = 0;
                                    newdata.forEach((a) => {
                                      if (a.name === "FAN") {
                                        toplam_++;
                                        a.value = "5 ";
                                      }
                                    });

                                    if (toplam_ < 1) {
                                      newdata.push({
                                        name: "FAN",
                                        value: "5 ",
                                      });
                                    }

                                    SETSetDegerleri2(true);

                                    e.target.parentElement.classList.toggle(
                                      "fan_modu_menu_active"
                                    );
                                    e.target.parentElement.previousElementSibling.innerHTML =
                                      "AUTO";
                                  }}
                                >
                                  AUTO
                                </li>
                              </ul>
                            </FormControl>
                            <IconButton
                              onClick={() => toggleLock(roomNumber, "mode")}
                              className={classes.lockButton}
                            >
                              {locked[roomNumber]?.mode ? (
                                <LockIcon />
                              ) : (
                                <LockOpenIcon />
                              )}
                            </IconButton>
                          </div>
                        );

                      case "Filtre Reset":
                        var değerler = props.vrf_tags
                          .filter((a) => String(a.tagId) === String(item[1][0]))
                          .map((b) => b.tagValue);
                        var değerler_eleman = değerler[0];
                        console.log(değerler_eleman);
                        return (
                          <div className={classes.statusRow}>
                            <Typography
                              variant="subtitle1"
                              className={classes.statusLabel}
                            >
                              {item[0]} :
                            </Typography>
                            <FormControl
                              variant="outlined"
                              className={classes.formControl}
                            >
                              <Button
                                labelId={`oda${roomNumber}-filtre-reset-label`}
                                id={`oda${roomNumber}-filtre-reset-buton`}
                                style={{
                                  fontWeight: 600,
                                  height: "2.5rem",
                                  backgroundColor: "green",
                                  width: "10rem",
                                  fontSize: "1rem",
                                  border: "2px solid black",
                                  borderRadius: "4px",
                                  color: "rgb(255, 255, 255)",
                                }}
                                onClick={() => {
                                  değerler_eleman = değerler_eleman.slice(
                                    0,
                                    -1
                                  );
                                  revisedState["Filtre Reset"].forEach(
                                    async (i) => {
                                      await sendSetValueFunc({
                                        TagId: i,
                                        TagValue: değerler_eleman,
                                      });
                                    }
                                  );
                                }}
                              >
                                RESET
                              </Button>
                            </FormControl>
                          </div>
                        );
                    }
                  }
                })}
              </div>
            );
          })}
        </div>
        {setDegerleri2 && (
          <div className="save_changes vrf-popup-save-changes">
            <p className="ofjs">Değişikleri Kaydet</p>
            <div className="btn-group">
              <i
                onClick={() => {
                  console.log("aa");
                  try {
                    for (let i of changed_values) {
                      console.log(i);
                      if (i.name === "FAN") {
                        // Fan Modu
                        initalState.forEach((item) => {
                          Object.values(item).forEach((values) => {
                            values.forEach((element) => {
                              if (element.text === "Fan Modu") {
                                let tagValue;

                                // Fan değerlerini belirle
                                switch (i.value) {
                                  case "DÜŞÜK":
                                    tagValue = "1 ";
                                    break;
                                  case "HIZLI":
                                    tagValue = "2 ";
                                    break;
                                  case "ORTA 2":
                                    tagValue = "3 ";
                                    break;
                                  case "ORTA":
                                    tagValue = "4 ";
                                    break;
                                  case "AUTO":
                                    tagValue = "5 ";
                                    break;
                                  default:
                                    tagValue = "5 "; // Default olarak AUTO
                                }

                                sendSetValueFunc({
                                  TagId: String(element.tagId2),
                                  TagValue: tagValue,
                                });
                              }
                            });
                          });

                          // Fan seçilen değerleri güncelle
                          const fanValue = i.value === "5" ? "AUTO" : i.value;
                          setfanmoduSelectValue({
                            101: fanValue,
                            102: fanValue,
                            103: fanValue,
                            104: fanValue,
                            105: fanValue,
                            106: fanValue,
                            107: fanValue,
                            108: fanValue,
                            109: fanValue,
                            110: fanValue,
                            111: fanValue,
                            112: fanValue,
                            114: fanValue,
                            115: fanValue,
                            116: fanValue,
                            117: fanValue,
                            118: fanValue,
                            119: fanValue,
                            201: fanValue,
                            202: fanValue,
                            203: fanValue,
                            204: fanValue,
                            205: fanValue,
                            206: fanValue,
                            207: fanValue,
                            208: fanValue,
                            209: fanValue,
                            210: fanValue,
                            211: fanValue,
                            212: fanValue,
                            213: fanValue,
                            214: fanValue,
                            301: fanValue,
                            302: fanValue,
                            303: fanValue,
                            304: fanValue,
                            305: fanValue,
                            306: fanValue,
                            307: fanValue,
                            308: fanValue,
                            309: fanValue,
                            310: fanValue,
                            311: fanValue,
                            312: fanValue,
                            401: fanValue,
                            402: fanValue,
                            403: fanValue,
                            404: fanValue,
                            405: fanValue,
                            406: fanValue,
                            407: fanValue,
                            408: fanValue,
                            501: fanValue,
                            502: fanValue,
                            503: fanValue,
                            504: fanValue,
                            505: fanValue,
                            506: fanValue,
                          });
                        });
                      } else if (i.name === "ÇALIŞMA") {
                        //Çalışma Modu

                        initalState.forEach((item) => {
                          Object.values(item).forEach((values) => {
                            values.forEach((element) => {
                              if (element.text === "Çalışma Modu") {
                                sendSetValueFunc({
                                  TagId: String(element.tagId2),
                                  TagValue: String(
                                    i.value === "SOĞUTMA"
                                      ? "1 "
                                      : i.value === "ISITMA"
                                      ? "2 "
                                      : i.value === "FAN"
                                      ? "3 "
                                      : i.value === "AUTO"
                                      ? "4 "
                                      : i.value === "NEM ALMA"
                                      ? "5 "
                                      : " "
                                  ),
                                });
                              }
                            });
                          });
                          setcalismamoduSelectValue({
                            101: i.value,
                            102: i.value,
                            103: i.value,
                            104: i.value,
                            105: i.value,
                            106: i.value,
                            107: i.value,
                            108: i.value,
                            109: i.value,
                            110: i.value,
                            111: i.value,
                            112: i.value,
                            114: i.value,
                            115: i.value,
                            116: i.value,
                            117: i.value,
                            118: i.value,
                            119: i.value,
                            201: i.value,
                            202: i.value,
                            203: i.value,
                            204: i.value,
                            205: i.value,
                            206: i.value,
                            207: i.value,
                            208: i.value,
                            209: i.value,
                            210: i.value,
                            211: i.value,
                            212: i.value,
                            213: i.value,
                            214: i.value,
                            301: i.value,
                            302: i.value,
                            303: i.value,
                            304: i.value,
                            305: i.value,
                            306: i.value,
                            307: i.value,
                            308: i.value,
                            309: i.value,
                            310: i.value,
                            311: i.value,
                            312: i.value,
                            401: i.value,
                            402: i.value,
                            403: i.value,
                            404: i.value,
                            405: i.value,
                            406: i.value,
                            407: i.value,
                            408: i.value,
                            501: i.value,
                            502: i.value,
                            503: i.value,
                            504: i.value,
                            505: i.value,
                            506: i.value,
                          });
                        });
                      } else if (i.name === "CİHAZ") {
                        //Cihaz
                        initalState.forEach((item) => {
                          Object.values(item).forEach((values) => {
                            values.forEach((element) => {
                              if (element.text === "Cihaz") {
                                sendSetValueFunc({
                                  TagId: String(element.tagId2),
                                  TagValue: String(
                                    i.value === "OFF" ? "0 " : "1 "
                                  ),
                                });
                              }
                            });
                          });
                          setcihazSelectValue({
                            101: i.value,
                            102: i.value,
                            103: i.value,
                            104: i.value,
                            105: i.value,
                            106: i.value,
                            107: i.value,
                            108: i.value,
                            109: i.value,
                            110: i.value,
                            111: i.value,
                            112: i.value,
                            114: i.value,
                            115: i.value,
                            116: i.value,
                            117: i.value,
                            118: i.value,
                            119: i.value,
                            201: i.value,
                            202: i.value,
                            203: i.value,
                            204: i.value,
                            205: i.value,
                            206: i.value,
                            207: i.value,
                            208: i.value,
                            209: i.value,
                            210: i.value,
                            211: i.value,
                            212: i.value,
                            213: i.value,
                            214: i.value,
                            301: i.value,
                            302: i.value,
                            303: i.value,
                            304: i.value,
                            305: i.value,
                            306: i.value,
                            307: i.value,
                            308: i.value,
                            309: i.value,
                            310: i.value,
                            311: i.value,
                            312: i.value,
                            401: i.value,
                            402: i.value,
                            403: i.value,
                            404: i.value,
                            405: i.value,
                            406: i.value,
                            407: i.value,
                            408: i.value,
                            501: i.value,
                            502: i.value,
                            503: i.value,
                            504: i.value,
                            505: i.value,
                            506: i.value,
                          });
                          Setcihazled({
                            101: i.value === "ON" ? "green" : "gray",
                            102: i.value === "ON" ? "green" : "gray",
                            103: i.value === "ON" ? "green" : "gray",
                            104: i.value === "ON" ? "green" : "gray",
                            105: i.value === "ON" ? "green" : "gray",
                            106: i.value === "ON" ? "green" : "gray",
                            107: i.value === "ON" ? "green" : "gray",
                            108: i.value === "ON" ? "green" : "gray",
                            109: i.value === "ON" ? "green" : "gray",
                            110: i.value === "ON" ? "green" : "gray",
                            111: i.value === "ON" ? "green" : "gray",
                            112: i.value === "ON" ? "green" : "gray",
                            114: i.value === "ON" ? "green" : "gray",
                            115: i.value === "ON" ? "green" : "gray",
                            116: i.value === "ON" ? "green" : "gray",
                            117: i.value === "ON" ? "green" : "gray",
                            118: i.value === "ON" ? "green" : "gray",
                            119: i.value === "ON" ? "green" : "gray",
                            201: i.value === "ON" ? "green" : "gray",
                            202: i.value === "ON" ? "green" : "gray",
                            203: i.value === "ON" ? "green" : "gray",
                            204: i.value === "ON" ? "green" : "gray",
                            205: i.value === "ON" ? "green" : "gray",
                            206: i.value === "ON" ? "green" : "gray",
                            207: i.value === "ON" ? "green" : "gray",
                            208: i.value === "ON" ? "green" : "gray",
                            209: i.value === "ON" ? "green" : "gray",
                            210: i.value === "ON" ? "green" : "gray",
                            211: i.value === "ON" ? "green" : "gray",
                            212: i.value === "ON" ? "green" : "gray",
                            213: i.value === "ON" ? "green" : "gray",
                            214: i.value === "ON" ? "green" : "gray",
                            301: i.value === "ON" ? "green" : "gray",
                            302: i.value === "ON" ? "green" : "gray",
                            303: i.value === "ON" ? "green" : "gray",
                            304: i.value === "ON" ? "green" : "gray",
                            305: i.value === "ON" ? "green" : "gray",
                            306: i.value === "ON" ? "green" : "gray",
                            307: i.value === "ON" ? "green" : "gray",
                            308: i.value === "ON" ? "green" : "gray",
                            309: i.value === "ON" ? "green" : "gray",
                            310: i.value === "ON" ? "green" : "gray",
                            311: i.value === "ON" ? "green" : "gray",
                            312: i.value === "ON" ? "green" : "gray",
                            401: i.value === "ON" ? "green" : "gray",
                            402: i.value === "ON" ? "green" : "gray",
                            403: i.value === "ON" ? "green" : "gray",
                            404: i.value === "ON" ? "green" : "gray",
                            405: i.value === "ON" ? "green" : "gray",
                            406: i.value === "ON" ? "green" : "gray",
                            407: i.value === "ON" ? "green" : "gray",
                            408: i.value === "ON" ? "green" : "gray",
                            501: i.value === "ON" ? "green" : "gray",
                            502: i.value === "ON" ? "green" : "gray",
                            503: i.value === "ON" ? "green" : "gray",
                            504: i.value === "ON" ? "green" : "gray",
                            505: i.value === "ON" ? "green" : "gray",
                            506: i.value === "ON" ? "green" : "gray",
                          });
                        });
                      } else if (i.name === "SET") {
                        //Oda Set Değeri
                        let value_all_set = i.value;
                        initalState.forEach((item) => {
                          Object.values(item).forEach((values) => {
                            values.forEach((element) => {
                              if (element.text === "Oda Set Değeri") {
                                sendSetValueFunc({
                                  TagId: String(element.tagId),
                                  TagValue: String(value_all_set),
                                });
                              }
                            });
                          });
                        });

                        setOdasetdegerler({
                          101: String(value_all_set),
                          102: String(value_all_set),
                          103: String(value_all_set),
                          104: String(value_all_set),
                          105: String(value_all_set),
                          106: String(value_all_set),
                          107: String(value_all_set),
                          108: String(value_all_set),
                          109: String(value_all_set),
                          110: String(value_all_set),
                          111: String(value_all_set),
                          112: String(value_all_set),
                          114: String(value_all_set),
                          115: String(value_all_set),
                          116: String(value_all_set),
                          117: String(value_all_set),
                          118: String(value_all_set),
                          119: String(value_all_set),
                          201: String(value_all_set),
                          202: String(value_all_set),
                          203: String(value_all_set),
                          204: String(value_all_set),
                          205: String(value_all_set),
                          206: String(value_all_set),
                          207: String(value_all_set),
                          208: String(value_all_set),
                          209: String(value_all_set),
                          210: String(value_all_set),
                          211: String(value_all_set),
                          212: String(value_all_set),
                          213: String(value_all_set),
                          214: String(value_all_set),
                          301: String(value_all_set),
                          302: String(value_all_set),
                          303: String(value_all_set),
                          304: String(value_all_set),
                          305: String(value_all_set),
                          306: String(value_all_set),
                          307: String(value_all_set),
                          308: String(value_all_set),
                          309: String(value_all_set),
                          310: String(value_all_set),
                          311: String(value_all_set),
                          312: String(value_all_set),
                          401: String(value_all_set),
                          402: String(value_all_set),
                          403: String(value_all_set),
                          404: String(value_all_set),
                          405: String(value_all_set),
                          406: String(value_all_set),
                          407: String(value_all_set),
                          408: String(value_all_set),
                          501: String(value_all_set),
                          502: String(value_all_set),
                          503: String(value_all_set),
                          504: String(value_all_set),
                          505: String(value_all_set),
                          506: String(value_all_set),
                        });
                      }
                    }
                    Set_changed_values([]);
                  } catch (err) {
                    console.log(err);
                  } finally {
                    SETSetDegerleri2(false);
                  }
                }}
                className="fa fa-check"
              ></i>
              <i
                onClick={() => {
                  SETSetDegerleri2(false);
                }}
                className="fa fa-times"
              ></i>
            </div>
          </div>
        )}
      </div>
    );
  };

  const classes = useStyles();
  const [open, setOpen] = useState(Array(1).fill(false));

  return (
    <div style={{ width: "100%", height: "100vh" }} className="main-d-vrf">
      <Link to="/">
        <Button
          className={classes.navigationButtonBack + " movebuttons"}
          variant="contained"
        >
          Geri
        </Button>
      </Link>
      <section style={{ width: "100%", height: "100%" }}>
        <div
          style={{
            width: "90%",
            height: "50%",
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            padding: "0 4% ",
            marginTop: "150px",
            justifyContent: "space-around",
          }}
          className="btn-group"
        >
          <button
            style={{
              backgroundColor: "rgb(237, 188, 69)",
              color: "rgb(45, 45, 45)",
              fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              border: "3px solid rgb(67, 51, 22)",
              borderRadius: "16px",
              padding: "10px",
              fontSize: "19px",
              fontWeight: "600",
              cursor: "pointer",
              outline: "none",
              appearance: "none",
              userSelect: "none",
              maxHeight: "120px",
              width: "calc(23% - 10px)",
              margin: "5px",
              transition: "0.3s",
              // Eklenen özellik: Hover durumunda arka plan rengini değiştir
              ":hover": {
                backgroundColor: "black",
                // black'i değiştirerek istediğiniz hover rengini ekleyin
              },
            }}
            onClick={() => {
              history.push("/vrf1");
            }}
          >
            Kat-1
          </button>
          <button
            style={{
              backgroundColor: "rgb(237, 188, 69)",
              color: "rgb(45, 45, 45)",
              fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              border: "3px solid rgb(67, 51, 22)",
              borderRadius: "16px",
              padding: "10px",
              fontSize: "19px",
              fontWeight: "600",
              cursor: "pointer",
              outline: "none",
              appearance: "none",
              userSelect: "none",
              maxHeight: "120px",
              width: "calc(23% - 10px)",
              margin: "5px",
              transition: "0.3s",
              // Eklenen özellik: Hover durumunda arka plan rengini değiştir
              ":hover": {
                backgroundColor: "black",
                // black'i değiştirerek istediğiniz hover rengini ekleyin
              },
            }}
            onClick={() => {
              history.push("/vrf2");
            }}
          >
            Kat-2
          </button>
          <button
            style={{
              backgroundColor: "rgb(237, 188, 69)",
              color: "rgb(45, 45, 45)",
              fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              border: "3px solid rgb(67, 51, 22)",
              borderRadius: "16px",
              padding: "10px",
              fontSize: "19px",
              fontWeight: "600",
              cursor: "pointer",
              outline: "none",
              appearance: "none",
              userSelect: "none",
              maxHeight: "120px",
              width: "calc(23% - 10px)",
              margin: "5px",
              transition: "0.3s",
              // Eklenen özellik: Hover durumunda arka plan rengini değiştir
              ":hover": {
                backgroundColor: "black",
                // YENI_RENK'i değiştirerek istediğiniz hover rengini ekleyin
              },
            }}
            onClick={() => {
              history.push("/vrf3");
            }}
          >
            Kat-3
          </button>
          <button
            style={{
              backgroundColor: "rgb(237, 188, 69)",
              color: "rgb(45, 45, 45)",
              fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              border: "3px solid rgb(67, 51, 22)",
              borderRadius: "16px",
              padding: "10px",
              fontSize: "19px",
              fontWeight: "600",
              cursor: "pointer",
              outline: "none",
              appearance: "none",
              userSelect: "none",
              maxHeight: "120px",
              width: "calc(23% - 10px)",
              margin: "5px",
              transition: "0.3s",
              // Eklenen özellik: Hover durumunda arka plan rengini değiştir
              ":hover": {
                backgroundColor: "black",
                // YENI_RENK'i değiştirerek istediğiniz hover rengini ekleyin
              },
            }}
            onClick={() => {
              history.push("/vrf4");
            }}
          >
            Kat-4
          </button>
          <button
            style={{
              backgroundColor: "rgb(237, 188, 69)",
              color: "rgb(45, 45, 45)",
              fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              border: "3px solid rgb(67, 51, 22)",
              borderRadius: "16px",
              padding: "10px",
              fontSize: "19px",
              fontWeight: "600",
              cursor: "pointer",
              outline: "none",
              appearance: "none",
              userSelect: "none",
              maxHeight: "120px",
              width: "240px",
              transition: "0.3s",
              // Eklenen özellik: Hover durumunda arka plan rengini değiştir
              ":hover": {
                backgroundColor: "black",
                // YENI_RENK'i değiştirerek istediğiniz hover rengini ekleyin
              },
            }}
            onClick={() => {
              history.push("/vrf5");
            }}
          >
            Kat-5
          </button>

          <button
            style={{
              backgroundColor: "rgb(237, 188, 69)",
              color: "rgb(45, 45, 45)",
              fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              border: "3px solid rgb(67, 51, 22)",
              borderRadius: "16px",
              padding: "10px",
              fontSize: "19px",
              fontWeight: "600",
              cursor: "pointer",
              outline: "none",
              appearance: "none",
              userSelect: "none",
              maxHeight: "120px",
              width: "240px",
              transition: "0.3s",
              // Eklenen özellik: Hover durumunda arka plan rengini değiştir
              ":hover": {
                backgroundColor: "black",
                // YENI_RENK'i değiştirerek istediğiniz hover rengini ekleyin
              },
            }}
            onClick={() => {
              history.push("/vrfhacim");
            }}
          >
            Ortak Hacim
          </button>

          <button
            style={{
              backgroundColor: "rgb(237, 188, 69)",
              color: "rgb(45, 45, 45)",
              fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              border: "3px solid rgb(67, 51, 22)",
              borderRadius: "16px",
              padding: "10px",
              fontSize: "19px",
              fontWeight: "600",
              cursor: "pointer",
              outline: "none",
              appearance: "none",
              userSelect: "none",
              maxHeight: "120px",
              width: "240px",
              transition: "0.3s",
              // Eklenen özellik: Hover durumunda arka plan rengini değiştir
              ":hover": {
                backgroundColor: "black",
                // YENI_RENK'i değiştirerek istediğiniz hover rengini ekleyin
              },
            }}
            onClick={() => {
              history.push("/vrfks");
            }}
          >
            Klima Santral
          </button>

          <button
            className="sistem_vrf_btn222"
            style={{
              backgroundColor: "rgb(237, 188, 69)",
              color: "rgb(45, 45, 45)",
              fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              border: "3px solid rgb(67, 51, 22)",
              borderRadius: "16px",
              padding: "10px",
              fontSize: "19px",
              fontWeight: "600",
              cursor: "pointer",
              outline: "none",
              appearance: "none",
              userSelect: "none",
              maxHeight: "120px",
              width: "240px",
              transition: "0.3s",
            }}
            onClick={() => {
              Set_active_rm2(true);
            }}
          >
            Sistem
          </button>
        </div>

        {active_rm2 && (
          <div key={"sistem1"}>
            <Modal
              aria-labelledby="transition-modal-title"
              aria-describedby="transition-modal-description"
              className={classes.modal}
              open={true}
              onClose={() => {}}
              closeAfterTransition
              BackdropComponent={Backdrop}
              BackdropProps={{
                timeout: 500,
              }}
            >
              {renderModalContent2("Sistem")}
            </Modal>
          </div>
        )}
      </section>
    </div>
  );
};

const MapStateToProps = (state) => {
  return {
    vrf_tags: state.project_reducer.vrf_tags,
  };
};

export default connect(MapStateToProps)(Dashboard_vrf);
